import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TChildrenRenderer } from 'react-native-render-html';

const SpanRenderer = ({ TDefaultRenderer, ...props }) => {
    const { tnode } = props;

    return (
        <View style={Styles.wrapper}>
            <TChildrenRenderer tchildren={tnode.children} renderChild={({ childElement }) => React.cloneElement(childElement)} />
        </View>
    );
};

const Styles = StyleSheet.create({
    wrapper: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center'
    }
});

export default SpanRenderer;
